var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowLightIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.16 390.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#aaaa79;}.cls-3{fill:#f7f1ae;}.cls-4{fill:#3d3d36;}.cls-5{fill:#30302c;}.cls-6{fill:#8e9167;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.39,229.85C517.13,227.5,318.89,21.4,311,13.07c-8.55-8.95-19.88-4.84-20.09-4.76.1,0,.66-.27-9.53,2.65-10.79,3.09-14.29-.8-14.29-.8s-4-5.24-17.63-1.28C233.58,13.45,7.86,70.81,7.86,70.81S.77,72.63.69,79.9,0,124.65,0,124.65,195.25,376,202.91,386c6.27,8.2,22,2.49,22,2.49s284.08-103,290.7-105.41c5.81-2.49,5.39-7.66,5.39-7.66l.13-37.91S521.36,232,519.39,229.85Zm-97-57.59-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L424.26,165C426.9,167.78,426.08,171.06,422.42,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M483.76,185.58c-1.89-2-167.09-173.72-173.71-180.65-7.11-7.46-16.56-4-16.74-4,.08,0,.55-.23-7.94,2.2-9,2.58-11.91-.66-11.91-.66s-3.29-4.36-14.69-1.07C245.58,5.24,57.48,53,57.48,53s-5.91,1.52-6,7.57-.58,37.3-.58,37.3S213.64,307.39,220,315.69c5.23,6.83,18.36,2.08,18.36,2.08S475.12,232,480.63,229.92c4.84-2.07,4.5-6.38,4.5-6.38l.1-31.59S485.4,187.34,483.76,185.58Zm-61.34-13.32-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L424.26,165C426.9,167.78,426.08,171.06,422.42,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M481.14,182.73S316.67,11.75,310.05,4.81c-7.11-7.46-16.56-4-16.74-4,.08,0,.55-.22-7.94,2.21-9,2.57-11.91-.66-11.91-.66S270.17-2,258.77,1.31C245.58,5.12,57.48,52.93,57.48,52.93s-8.71,3-3.6,9.42c5.37,7.05,48.6,63.65,48.6,63.65S210,261.24,218,271.29s23.12,3.88,23.12,3.88,227.06-77.39,237.78-81S481.14,182.73,481.14,182.73Zm-58.72-10.47-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L424.26,165C426.9,167.78,426.08,171.06,422.42,172.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.84 281.15 242.84 308.67 475.65 224.48 475.65 201.17 242.84 281.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "475.65 201.17 459.31 206.84 475.65 224.48 475.65 201.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.18,128.13l-7.76,1.57C122.69,151.42,210.78,262.23,218,271.29A15.61,15.61,0,0,0,229.78,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M481.14,182.73S410.61,109.41,360.07,56.84L356,58.58,483.4,191.4C486.43,187.57,481.14,182.73,481.14,182.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.72,58.53C109.25,60.72,91,67.2,101.08,80.09S126,93.35,143.5,88.52s132.73-36.46,143.9-39.6,25.7-9.77,12.89-21.8-30.41-8.71-44.76-4.92S126.2,56.33,117.72,58.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M318.13,13.22l-2-2-25.08,6.74a31.13,31.13,0,0,1,3.67,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.51,70.72,65.82,78.07l1.92,2.51,25.8-6.91A9.15,9.15,0,0,1,93.51,70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.34,17.6l-1.95-2-22.27,6a28.92,28.92,0,0,1,2.44,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.33,82.62l1.93,2.5,24.23-6.47A17.48,17.48,0,0,1,94.2,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M304.67,27.77l21.75-5.92-1.94-2-21.6,5.86c.32.33.63.67.94,1S304.4,27.42,304.67,27.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.31,81.29,73.24,87.8l1.94,2.49L99.32,83.7c-.48-.53-.95-1.08-1.42-1.65C97.68,81.79,97.5,81.54,97.31,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77,92.56l2,2.49,25.16-6.89c-.87-.69-1.73-1.44-2.59-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.51,26.1l-1.94-2-22.24,6.05a15.89,15.89,0,0,1,1.18,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.16,96.8l2,2.48,27.69-7.54a30.71,30.71,0,0,1-3.51-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M308.31,37.37l26.16-7.16-1.93-2-24.31,6.61A8.81,8.81,0,0,1,308.31,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M430.37,165.28,330.76,59.9a16.45,16.45,0,0,0-14.85-4.11l-183.54,51.5c-4.76,1.34-6.12,5.59-3,9.44l94.32,117.15a14,14,0,0,0,14.19,4.17L428,174.66C432.71,173.1,433.77,168.87,430.37,165.28Zm-7.95,7-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L424.26,165C426.9,167.78,426.08,171.06,422.42,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M331.19,217.59c-3.12-1.08-3.11-2.79,0-3.82l22.32-7.3c3.13-1,5.27.8,4.74,4.06l-1.55,9.58a4.9,4.9,0,0,1-6.63,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLightIsometric);
export default __webpack_public_path__ + "static/media/yellow-light-isometric.f284aef0c2f3f446fa26d6cdae61eda9.svg";
export { ForwardRef as ReactComponent };